import { BaSeTheme } from '@base/react';
import styled, { css, keyframes } from 'styled-components';

export const buttonColor = '#231023';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(0.97);
    opacity: 0.5;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 799px;
  align-items: center;
  gap: 20px;
`;

export const ContentStepperThree = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TextHeaderWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 16px;

  ${handleQuery(`
     width: 90%;
  `)}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 4px;
  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  width: 100%;

  ${handleQuery(`
     width: 90%;
  `)}
`;

export const ContentSelectionInterview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;

  ${handleQuery(`
     padding: 16px;
  `)}
`;

export const Separator = styled.hr`
  margin: 0;
  border: none;
  height: 1px;
  background: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${({ orientation }) =>
    orientation === 'vertical' &&
    css`
      flex-direction: row;
      gap: 8px;
    `}
`;

export const StepperContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const AnswerWrapper = styled.div`
  position: relative;
  padding-top: 4px;

  textarea {
    text-align: justify;
    text-justify: inter-word;
    padding: 12px 32px 12px 16px;

    ${handleQuery(`
      padding: 4px 10px;
    `)}
  }
`;

export const recordContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MicrophoneWrapper = styled.div``;

export const Microphone = styled.div`
  background-image: url('https://base-estatico.sebrae.com.br/images/icons/microphone.svg');
  /* filter: invert(28%) sepia(7%) saturate(2258%) hue-rotate(168deg)
    brightness(95%) contrast(90%); */
  cursor: pointer;
  position: absolute;
  height: 22px;
  width: 22px;
  top: 20px;
  right: 18px;

  ${({ recording }) =>
    recording &&
    css`
      animation: ${fadeOut} 600ms alternate infinite;
      filter: invert(16%) sepia(86%) saturate(3076%) hue-rotate(13deg)
        brightness(97%) contrast(108%);

      &:hover {
        background-image: url('https://base-estatico.sebrae.com.br/images/icons/microphone-slash.svg');
      }
    `}
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  /* ${({ isDisabled }) =>
    !isDisabled &&
    css`
      .BaSe--button {
        border: 1px solid #bf303c;
      }
    `} */
`;

export const InfoHeader = styled.div`
  display: flex;
  gap: 10px;
`;

export const InfoBody = styled.div`
  padding-top: 5px;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ContainerMessages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 5px;
`;

export const Circulo = styled.div`
  padding: 4px;
  margin-top: 6px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
`;

export const AlignText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8;

  strong {
    font-weight: 900;
    font-size: 1.2rem;
  }
`;

export const WrapperSupportMessage = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ContentMic = styled.div`
  :hover {
    background-color: red;
  }
`;
